var _ellipse, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 12.0779,
    rx: 11.5,
    ry: 11.638,
    fill: "#757575"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3601 6.65362L8.34561 12.7403L8.3456 12.7403C7.92585 13.1651 7.71598 13.3775 7.5782 13.6375C7.44043 13.8975 7.38253 14.1904 7.26675 14.7763L7.02041 16.0227C6.95465 16.3555 6.92177 16.5219 7.01659 16.6163C7.11142 16.7107 7.27765 16.677 7.61011 16.6097L8.80514 16.3679C9.39815 16.2479 9.69465 16.1878 9.95681 16.0461C10.219 15.9044 10.4316 15.6892 10.8569 15.2589L16.8899 9.15345C17.5744 8.46074 17.5744 7.34633 16.8899 6.65362C16.1938 5.94913 15.0562 5.94913 14.3601 6.65362Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 6.00635V6.00635C12.4574 8.56046 14.3258 10.6281 16.8081 11.4654L17.5 11.6988",
    stroke: "#757575",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/CreateIcon.b6dc982667ad44bed701733b652d2e8c.svg";
export { ForwardRef as ReactComponent };